import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EscalationScopeService } from '../tokens/escalation-scope.token';
import { EscalationScope } from '../models/escalation-scope.model';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-backed implementation of `EscalationScopeService` (EM-1890).
 *
 * GET /services/embedded/api/master-admin/escalation-scope → EscalationScope (ROLE_MASTER_ADMIN).
 *
 * Rule 10 — no mock fallback. Errors propagate; the page surfaces them per Rule 09.
 */
@Injectable()
export class EscalationScopeRestService implements EscalationScopeService {
  private readonly http = inject(HttpClient);

  get(): Observable<EscalationScope> {
    return this.http.get<EscalationScope>(`${API_PATHS.EMBEDDED_API_BASE}/master-admin/escalation-scope`);
  }
}
